<div class="dialog-content">
  <div class="dialog-header">
    <span class="dialog-heading">
      <span *ngIf="importingData.action === 'Add'">Add a new code</span>
      <span *ngIf="importingData.action != 'Add'">Edit code</span>
    </span>
    <mat-icon class="h-24-w-24 cursor-pointer" mat-dialog-close>close</mat-icon>
  </div>
  <p class="company" *ngIf="importingData.action === 'Add'">
    To create new code, ensure the <span style="color: #3C3C43;">Company</span> and
    <span style="color: #3C3C43;">Code</span> fields are mandatory while ensuring that at least
    three fields are filled before finalising the code.
  </p>

  <ng-container *ngIf="importingData.action === 'Add'; else editBlock">
    <form #form="ngForm">
      <div class="wrapper">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ "codeFormConfig.company" | translate }}</mat-label>
          <input name="company" matInput [(ngModel)]="sifraData.companyName" />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ "codeFormConfig.code" | translate }}</mat-label>
          <input name="code" matInput [(ngModel)]="sifraData.code" />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>ID Number</mat-label>
          <input
            pattern="[0-9]*"
            name="number"
            matInput
            [(ngModel)]="sifraData.idNumber"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>VAT Number</mat-label>
          <input
            pattern="[0-9]*"
            name="vatNumber"
            matInput
            [(ngModel)]="sifraData.vatNumber"
          />
        </mat-form-field>
      </div>
      <div class="action-button">
        <button
          class="primary-button"
          [disabled]="!form.valid || !isOneFieldFilled()"
          [promiseBtn]="adding"
          (click)="addNewSifraFromDialog()"
        >
          <mat-icon>add</mat-icon>
          <span class="ml-8">{{ "addNewCode" | translate }}</span>
        </button>
      </div>
    </form>
  </ng-container>
  <ng-template #editBlock>
    <form #form="ngForm">
      <div class="wrapper">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Company</mat-label>
          <input
            name="company"
            matInput
            [(ngModel)]="sifraDataEdit.companyName"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Code</mat-label>
          <input name="code" matInput [(ngModel)]="sifraDataEdit.code" />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>ID Number</mat-label>
          <input name="number" matInput [(ngModel)]="sifraDataEdit.idNumber" />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>VAT Number</mat-label>
          <input
            name="vatNumber"
            matInput
            [(ngModel)]="sifraDataEdit.vatNumber"
          />
        </mat-form-field>
      </div>
      <div class="action-button">
        <button
          class="primary-button"
          [disabled]="!form.valid || !isFormDirty() || !isOneFieldFilled()"
          [promiseBtn]="adding"
          (click)="editSifraFromDialog()"
        >
          <mat-icon>add</mat-icon>
          <span class="ml-8">{{ "Update code" | translate }}</span>
        </button>
      </div>
    </form>
  </ng-template>
</div>
